<template>
  <div class="driver-orders-page">
    <el-tabs v-model="orderTab" @tab-click="handleTabChange">
      <el-tab-pane label="顺风车订单" name="hitchRide">
        <div class="table-toolbar">
          <span class="total-info">共 {{ hitchRidePage.total }} 条记录</span>
        </div>
        <el-table :data="hitchRideOrders" v-loading="hitchRideLoading" size="small" stripe border>
          <el-table-column label="订单号" prop="orderNo" width="160" show-overflow-tooltip />
          <el-table-column label="起点" prop="startPointName" min-width="120" show-overflow-tooltip />
          <el-table-column label="终点" prop="endPointName" min-width="120" show-overflow-tooltip />
          <el-table-column label="状态" prop="status" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="hitchRideStatusType(row.status)" size="mini">{{ hitchRideStatusText(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="服务费" prop="serviceFee" width="90">
            <template slot-scope="{ row }">
              <span class="money">￥{{ (row.serviceFee || 0).toFixed ? (row.serviceFee || 0).toFixed(2) : row.serviceFee || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="乘客数" prop="passengerNum" width="70" align="center" />
          <el-table-column label="下单时间" prop="created" width="150">
            <template slot-scope="{ row }">{{ row.created | filterTime }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          background
          layout="total, prev, pager, next"
          :total="hitchRidePage.total"
          :current-page.sync="hitchRidePage.page"
          :page-size="hitchRidePage.size"
          @current-change="loadHitchRideOrders"
        />
      </el-tab-pane>

      <el-tab-pane label="班车订单" name="bus">
        <div class="table-toolbar">
          <span class="total-info">共 {{ busPage.total }} 条记录</span>
        </div>
        <el-table :data="busOrders" v-loading="busLoading" size="small" stripe border>
          <el-table-column label="班次ID" prop="orderLineId" width="100" />
          <el-table-column label="司机姓名" prop="driverName" width="90" />
          <el-table-column label="车辆号牌" prop="licenseNo" width="110" />
          <el-table-column label="载客数" prop="passengerAllNum" width="70" align="center" />
          <el-table-column label="状态" prop="status" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="busStatusType(row.status)" size="mini">{{ busStatusText(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="实收金额" prop="realTotalFee" width="100">
            <template slot-scope="{ row }">
              <span class="money">￥{{ (row.realTotalFee || 0) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出发时间" prop="serviceTime" width="150">
            <template slot-scope="{ row }">{{ row.serviceTime | filterTime }}</template>
          </el-table-column>
          <el-table-column label="完成时间" prop="finishTime" width="150">
            <template slot-scope="{ row }">{{ row.finishTime | filterTime }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          background
          layout="total, prev, pager, next"
          :total="busPage.total"
          :current-page.sync="busPage.page"
          :page-size="busPage.size"
          @current-change="loadBusOrders"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'DriverOrdersPage',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      orderTab: 'hitchRide',
      hitchRideOrders: [],
      hitchRideLoading: false,
      hitchRidePage: { page: 1, size: 10, total: 0 },
      busOrders: [],
      busLoading: false,
      busPage: { page: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.loadHitchRideOrders()
  },
  methods: {
    handleTabChange(tab) {
      if (tab.name === 'bus' && this.busOrders.length === 0) {
        this.loadBusOrders()
      }
    },
    async loadHitchRideOrders(page = 1) {
      if (!this.info || !this.info.id) return
      this.hitchRideLoading = true
      this.hitchRidePage.page = page
      const res = await this.$axios.get(`/api/v1/manage/driver/${this.info.id}/hitchRideOrders`, {
        page: this.hitchRidePage.page,
        size: this.hitchRidePage.size
      })
      if (res && res.code === 1 && res.data) {
        this.hitchRideOrders = res.data.records || []
        this.hitchRidePage.total = res.data.total || 0
      }
      this.hitchRideLoading = false
    },
    async loadBusOrders(page = 1) {
      if (!this.info || !this.info.id) return
      this.busLoading = true
      this.busPage.page = page
      const res = await this.$axios.get(`/api/v1/manage/driver/${this.info.id}/busOrders`, {
        page: this.busPage.page,
        size: this.busPage.size
      })
      if (res && res.code === 1 && res.data) {
        this.busOrders = res.data.records || []
        this.busPage.total = res.data.total || 0
      }
      this.busLoading = false
    },
    hitchRideStatusText(status) {
      const map = { 1: '待接单', 2: '已接单', 3: '已取消', 4: '行程中', 10: '已完成' }
      return map[status] || status
    },
    hitchRideStatusType(status) {
      const map = { 1: 'info', 2: 'warning', 3: 'danger', 4: 'primary', 10: 'success' }
      return map[status] || ''
    },
    busStatusText(status) {
      const map = { 0: '初始', 1: '待发车', 2: '行程中', 3: '已完成', 4: '已取消' }
      return map[status] || status
    },
    busStatusType(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'primary', 3: 'success', 4: 'danger' }
      return map[status] || ''
    }
  }
}
</script>

<style lang="less" scoped>
.driver-orders-page {
  height: 100%;
  .table-toolbar {
    margin-bottom: 8px;
    .total-info {
      font-size: 13px;
      color: #909399;
    }
  }
  .money {
    color: #E6A23C;
    font-weight: 500;
  }
  .pagination {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
